<template>
  <hi-list :items="groupMailList" @select="select">
    <template v-slot="{ item }">
      <v-list-item-content>
        {{ item.name }}
      </v-list-item-content>
    </template>
  </hi-list>
</template>

<script>
import HiList from "@/components/HiList";
// import { mapActions, mapGetters } from "vuex";
// import EdmCampaignSummary from "@/components/edm/EdmCampaignSummary";
import { db } from "@/db";
// import { collection } from "@/store/modules/db";

export default {
  name: "GroupMailList",
  components: { HiList },
  data() {
    return {
      // campaignList: [],
      selected: null,
      groupMailList: null
    };
  },
  firestore: {
    groupMailList: db.collection("emails/data/groupMails")
  },
  methods: {
    select(item) {
      this.$router.replace({ path: `/edm/group-mails/${item.id}` });
    }
  }
};
</script>

<style scoped></style>
